import { Flex, Text, FlexProps, Spinner } from '@chakra-ui/react'
import { Trans } from '@lingui/react/macro'
import { colors } from '../../theme/cssVariables'

export default function LoadMoreIcon({ isLoading, ...props }: FlexProps & { isLoading?: boolean }) {
  return (
    <Flex
      alignItems={'center'}
      gap={2}
      cursor={'pointer'}
      color={colors.colorB3}
      _hover={{ color: colors.colorB1 }}
      {...props}
    >
      {isLoading ? (
        <Spinner size="sm" />
      ) : (
        <>
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.5 6.59829C13.5737 4.48012 11.4597 3 9 3C5.68629 3 3 5.68629 3 9C3 12.3137 5.68629 15 9 15C11.6124 15 13.8349 13.3304 14.6586 11"
              stroke="currentColor"
              stroke-width="2"
            />
            <path d="M15 2V7H10" stroke="currentColor" stroke-width="2" />
          </svg>
          <Text fontSize={'sm'} textTransform={'uppercase'}>
            <Trans>load more</Trans>
          </Text>
        </>
      )}
    </Flex>
  )
}
